// #ux-redesign-start: BtnDelete migra SweetAlert → ConfirmDialog DS
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslate } from 'react-translate';

import { Button, ConfirmDialog } from 'components/ds';
import {
  actionSetSelectedMessages,
  actionDelMessages,
} from 'store/actions/messagesActions';

const BtnDelete = ({ mobile }) => {
  const t = useTranslate('messages');
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);

  const { selectedMessages } = useSelector((state) => state.messagesReducer);

  const onConfirm = () => {
    dispatch(actionDelMessages({ messages: selectedMessages }));
    dispatch(actionSetSelectedMessages([]));
    setOpen(false);
  };

  return (
    <>
      <Button
        variant="danger"
        size={mobile ? 'sm' : 'md'}
        onClick={() => setOpen(true)}
        disabled={selectedMessages.length <= 0}
        name="btn-menu-delete"
        iconLeft={<span className="icon-trash" />}
      >
        {!mobile && t('btn-delete')}
      </Button>
      <ConfirmDialog
        isOpen={open}
        title={t('alert-delete-title')}
        description={t('alert-delete-subtitle')}
        confirmLabel={t('alert-delete-btn-ok')}
        cancelLabel={t('alert-delete-btn-cancel')}
        variant="danger"
        onConfirm={onConfirm}
        onCancel={() => setOpen(false)}
      />
    </>
  );
};

export default BtnDelete;
// #ux-redesign-end
